import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { sendAnalyticsEvent } from "../lib/analytics";

export const AnalyticsNavigation = () => {
    const { pathname } = useLocation();
    const lastPath = useRef(null);
    useEffect(() => {
        if (lastPath.current === pathname) return;
        lastPath.current = pathname;
        sendAnalyticsEvent("page_view", {}, pathname);
    }, [pathname]);
    return null;
};